import { render, staticRenderFns } from "./Memoria.vue?vue&type=template&id=6b423548&scoped=true&"
import script from "./Memoria.vue?vue&type=script&lang=js&"
export * from "./Memoria.vue?vue&type=script&lang=js&"
import style0 from "./Memoria.vue?vue&type=style&index=0&id=6b423548&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b423548",
  null
  
)

export default component.exports